// A proposal TEMPLATE is the document whose headings become the proposal's
// sections, so it has to be a prose document Pandoc can parse.
export const PROPOSAL_DOC_EXTENSIONS = ['.docx', '.pdf'] as const

// A proposal SOURCE is grounding content the draft draws on, which is a wider
// set than a template: a pinned spreadsheet is the whole point of the
// deterministic tabular figures the proposal agent computes in Go, and the
// backend's own corpus loader accepts it. Sharing one predicate with the
// template gate silently made that feature unreachable through the UI, because
// a user could not pin a spreadsheet to a proposal at all.
//
// This is deliberately narrower than the backend's supportedRagFileTypes, which
// also accepts .pptx, .txt and .eml. Whether those belong in a proposal's source
// picker is a separate product question; this list covers the prose sources the
// picker already offered plus the tabular ones the compute path needs.
export const PROPOSAL_SOURCE_EXTENSIONS = ['.docx', '.pdf', '.xlsx', '.csv'] as const

function hasExtension(fileName: string, extensions: ReadonlyArray<string>): boolean {
  const lower = fileName.toLowerCase()
  return extensions.some((ext) => lower.endsWith(ext))
}

export function isProposalDocFile(fileName: string): boolean {
  return hasExtension(fileName, PROPOSAL_DOC_EXTENSIONS)
}

export function isProposalSourceFile(fileName: string): boolean {
  return hasExtension(fileName, PROPOSAL_SOURCE_EXTENSIONS)
}
